import { render, staticRenderFns } from "./project-features.vue?vue&type=template&id=5fa31bc0&scoped=true&lang=html&"
import script from "./project-features.vue?vue&type=script&lang=js&"
export * from "./project-features.vue?vue&type=script&lang=js&"
import style0 from "./project-features.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./project-features.vue?vue&type=style&index=1&id=5fa31bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa31bc0",
  null
  
)

component.options.__file = "project-features.vue"
export default component.exports